/**
 * Product card pack-size pill switcher.
 *
 * Each bundle card renders a button (.card__pack-pill) per pack size the
 * product offers (24 / 12 / 6). Clicking a pill updates the per-can price
 * display in the same card (data-card-price-display) and moves the active
 * state to the clicked pill. Pure cosmetic: does not navigate or change cart.
 *
 * Single delegated listener for all cards on the page.
 */
(function () {
  document.addEventListener('click', function (event) {
    var pill = event.target.closest('.card__pack-pill');
    if (!pill) return;

    var group = pill.closest('.card__pack-pills');
    var bundlePrice = pill.closest('.card__bundle-price');
    if (!group || !bundlePrice) return;

    event.preventDefault();
    event.stopPropagation();

    var perCan = pill.getAttribute('data-per-can') || '';
    var display = bundlePrice.querySelector('[data-card-price-display]');

    if (display && perCan) {
      display.textContent = perCan;
    }

    var siblings = group.querySelectorAll('.card__pack-pill');
    for (var i = 0; i < siblings.length; i++) {
      siblings[i].classList.remove('card__pack-pill--active');
      siblings[i].setAttribute('aria-pressed', 'false');
    }
    pill.classList.add('card__pack-pill--active');
    pill.setAttribute('aria-pressed', 'true');
  });
})();
